import type { NextPage, GetStaticProps } from 'next';
import type { PageProps, QueryData } from '@/types/index';
import DefaultErrorPage from 'next/error';
import { useIsPreviewing } from '@builder.io/react';
import { restRequest } from '@/utils/restRequest';
import PageHead from '@/components/Head';
import LegalPage from '@/components/LegalPage';
import { domain } from '@/constants/config';

// set revalidate from env. This determines how long the pages will cache and
// therefore how long changes will take to appear
const revalidate = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 3600 : 1;
export const getStaticProps: GetStaticProps = async () => {
  /**
   * Calls for terms and conditions data
   *
   * @note Using aliases to match data definition
   *
   */

  // Need to use different terms and conditions for SMS on totalinjuryhelp.com
  const withSMS = domain === 'a3b98c26514c47659320d31f5308af20';
  const legalId = withSMS ? 'afed97d3f1a346b08677760410b94099' : 'a7065d75557648e8ac06eb793a667fff';
  const termsDataArr = await restRequest<QueryData<'page'>[]>({
    modelName: 'legal',
    query: `id=${legalId}`
  });
  const legalData = termsDataArr?.length && termsDataArr.length > 0 ? termsDataArr[0] : null;
  return {
    props: {
      content: {
        legalData
      }
    },
    revalidate
  };
};
export const Page: NextPage<PageProps> = ({
  content
}) => {
  const isPreviewing = useIsPreviewing();
  if (!content.legalData && !isPreviewing) {
    return <DefaultErrorPage statusCode={404} />;
  }
  const termsRichText = content.legalData?.data.text || null;
  return <>
			<PageHead path="/terms-and-conditions" title={'Total Injury Help | Terms and Conditions'} description="" shareImage="/TotalInjuryHelp_logo.webp" data-sentry-element="PageHead" data-sentry-source-file="terms-and-conditions.tsx" />

			{termsRichText && <LegalPage text={termsRichText} />}
		</>;
};
export default Page;